import type { CSSProperties } from "react";

type BorderBeamProps = {
  className?: string;
  size?: number;
  duration?: number;
  borderWidth?: number;
  anchor?: number;
  colorFrom?: string;
  colorTo?: string;
  delay?: number;
};

export function BorderBeam({
  className = "",
  size = 170,
  duration = 3.5,
  anchor = 90,
  borderWidth = 2.5,
  colorFrom,
  colorTo,
  delay = 0,
}: BorderBeamProps) {
  const style = {
    "--beam-size": size,
    "--beam-duration": duration,
    "--beam-anchor": anchor,
    "--beam-border-width": borderWidth,
    "--beam-delay": `-${delay}s`,
    ...(colorFrom ? { "--beam-color-from": colorFrom } : {}),
    ...(colorTo ? { "--beam-color-to": colorTo } : {}),
  } as CSSProperties;

  return (
    <span
      aria-hidden="true"
      className={`border-beam${className ? ` ${className}` : ""}`}
      style={style}
    />
  );
}
